export default __webpack_public_path__ + "static/media/7.7b7c4b65.png";